module.exports = " <div class=\"list von-radio\" thin-border=\"\" _v-2002f0e2=\"\"> <label class=\"item item-icon-left\" v-for=\"(index, option) in options\" _v-2002f0e2=\"\"> <input type=radio name=\"{{ radioId }}\" @click=onOptionClick(index) _v-2002f0e2=\"\"> <i class=\"{{ 'icon ion-ios-checkmark ' + (value == index ? theme : 'grey') }}\" _v-2002f0e2=\"\"></i> <span _v-2002f0e2=\"\">{{ option }}</span> </label> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-2002f0e2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/radio/index.vue
// module id = 255
// module chunks = 0